// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2vpXS","buttons":"Footer_buttons__3m2dw"};